/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreStoreDataResponseStoreMeta interface.
 */
export function instanceOfFxIdWebFeaturesStoreStoreDataResponseStoreMeta(value) {
    if (!('SubscriptionsSupported' in value) || value['SubscriptionsSupported'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreStoreDataResponseStoreMetaFromJSON(json) {
    return FxIdWebFeaturesStoreStoreDataResponseStoreMetaFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreStoreDataResponseStoreMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'SubscriptionsSupported': json['SubscriptionsSupported'],
    };
}
export function FxIdWebFeaturesStoreStoreDataResponseStoreMetaToJSON(json) {
    return FxIdWebFeaturesStoreStoreDataResponseStoreMetaToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreStoreDataResponseStoreMetaToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'SubscriptionsSupported': value['SubscriptionsSupported'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreStoreDataResponseStoreMeta.js.map